enum DashboardRoutes {
  Dashboard = '/dashboard',
}

export default DashboardRoutes
